import AiTextImprovement from "../../../../../components/ai/AiTextImprovement";
import { CampaignChannel, MessageTemplate } from "./types";

interface MessageCardProps {
  value: string;
  channel: CampaignChannel;
  templates: MessageTemplate[];
  selectedTemplateId: number | null;
  templatesLoading: boolean;
  templatesError: string | null;
  tokens: string[];
  onChange: (value: string) => void;
  onTokenClick: (token: string) => void;
  onTemplateChange: (templateId: number | null) => void;
}

export default function MessageCard({
  value,
  channel,
  templates,
  selectedTemplateId,
  templatesLoading,
  templatesError,
  tokens,
  onChange,
  onTokenClick,
  onTemplateChange,
}: MessageCardProps) {
  const maxCharacters = 160;
  const remainingCharacters = Math.max(maxCharacters - value.length, 0);

  return (
    <div className="card">
      <div className="card-title">Message Builder</div>

      {channel === "WHATSAPP" ? (
        <div className="form-group message-builder-field">
          <label className="form-label" htmlFor="campaign-template">
            Approved WhatsApp template
          </label>
          <select
            id="campaign-template"
            className="form-input"
            value={selectedTemplateId ?? ""}
            onChange={(event) =>
              onTemplateChange(event.target.value ? Number(event.target.value) : null)
            }
            disabled={templatesLoading}
          >
            <option value="">
              {templatesLoading ? "Loading templates..." : "Select a template"}
            </option>
            {templates.map((template) => (
              <option
                key={template.messageTemplateId}
                value={template.messageTemplateId}
              >
                {template.name}
              </option>
            ))}
          </select>
          {templatesError && <div className="form-error">{templatesError}</div>}
          {!templatesLoading && !templatesError && templates.length === 0 && (
            <div className="field-hint">
              No approved WhatsApp templates are available for this organisation.
            </div>
          )}
          {selectedTemplateId && (
            <>
              <label className="form-label" htmlFor="campaign-message">
                Message preview
              </label>
              <textarea
                id="campaign-message"
                className="form-input"
                rows={5}
                value={value}
                readOnly
              />
              <div className="field-hint">
                Template variables are populated separately for each recipient when the campaign is sent.
              </div>
            </>
          )}
        </div>
      ) : (
      <div className="form-group message-builder-field">
        <label className="form-label" htmlFor="campaign-message">
          Message
        </label>
        <div
          className="form-actions message-template-fields"
          aria-label="Message template fields"
        >
          {tokens.map((token) => (
            <button
              key={token}
              type="button"
              className="link-button"
              onClick={() => onTokenClick(token)}
            >
              {token}
            </button>
          ))}
        </div>
        <textarea
          id="campaign-message"
          className="form-input"
          rows={5}
          value={value}
          onChange={(event) => onChange(event.target.value)}
        />
        <div className="summary-name">
          {remainingCharacters}/{maxCharacters} characters remaining
        </div>
      </div>
      )}

      {channel === "SMS" && <AiTextImprovement
        documentType="Sms"
        fields={[{ name: "message", label: "Message", value }]}
        actions={[
          { value: "Improve", label: "Improve wording" },
          { value: "Shorten", label: "Shorten message" },
          { value: "Friendly", label: "Make friendlier" },
          { value: "Professional", label: "Make professional" },
        ]}
        onApply={(fields) => {
          if (fields.message !== undefined) onChange(fields.message);
        }}
      />}
    </div>
  );
}
